import React, { useState } from "react";
import Logo from "../resources/Logo petromin.png";
import { useLocation, Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const close = () => setOpen(false);

  const isActive = (path) =>
    path === '/stavebniny'
      ? location.pathname === '/stavebniny'
      : location.pathname.startsWith(path);

  const linkClass = (path) =>
    `p-2 rounded transition-colors duration-200 ${
      isActive(path) ? 'bg-red-600 text-white' : 'hover:bg-red-700 hover:text-white'
    }`;

  const links = [
    { to: '/stavebniny', label: 'Domov' },
    { to: '/ponuka', label: 'Ponuka' },
    { to: '/doprava', label: 'Doprava' },
    { to: '/cerpacia-stanica', label: 'Čerpacia stanica' },
    { to: '/contact', label: 'Kontakt' },
  ];

  return (
    <>
      <nav className="bg-white shadow-xl z-50 fixed top-0 left-0 w-full">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-red-600" />
        <div className="px-6 flex justify-between items-center mx-auto h-24">
          <Link to="/">
            <img src={Logo} alt="logo" className="h-12" />
          </Link>

          {/* Desktop links */}
          <div className="items-center space-x-2 text-xl font-semibold hidden lg:flex">
            {links.filter(l => l.to !== '/cerpacia-stanica').map(l => (
              <Link key={l.to} to={l.to} className={linkClass(l.to)}>{l.label}</Link>
            ))}
          </div>

          {/* Animated hamburger button */}
          <button
            className="lg:hidden flex flex-col justify-center items-center w-10 h-10 gap-[5px] cursor-pointer"
            onClick={() => setOpen(prev => !prev)}
            aria-label="Menu"
          >
            <span className={`block w-6 h-[2px] bg-gray-800 transition-all duration-300 origin-center ${open ? 'rotate-45 translate-y-[7px]' : ''}`} />
            <span className={`block w-6 h-[2px] bg-gray-800 transition-all duration-300 ${open ? 'opacity-0 scale-x-0' : ''}`} />
            <span className={`block w-6 h-[2px] bg-gray-800 transition-all duration-300 origin-center ${open ? '-rotate-45 -translate-y-[7px]' : ''}`} />
          </button>
        </div>
      </nav>

      {/* Full-screen mobile overlay */}
      <div className={`fixed inset-0 z-40 bg-gray-950 flex flex-col transition-all duration-300 lg:hidden ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        {/* Top bar inside overlay */}
        <div className="flex justify-between items-center px-6 h-24 border-b border-gray-800">
          <Link to="/" onClick={close}>
            <img src={Logo} alt="logo" className="h-10 brightness-0 invert" />
          </Link>
        </div>

        {/* Nav links */}
        <nav className="flex-1 flex flex-col justify-center px-8 gap-1">
          {links.map((l, i) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={close}
              style={{ transitionDelay: open ? `${i * 50}ms` : '0ms' }}
              className={`text-3xl font-bold py-4 border-b border-gray-800 transition-all duration-300 ${
                open ? 'translate-x-0 opacity-100' : '-translate-x-6 opacity-0'
              } ${isActive(l.to) ? 'text-red-500' : 'text-white hover:text-red-400'}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* Footer inside overlay */}
        <div className="px-8 pb-10 text-gray-600 text-sm">
          © Petromin s.r.o.
        </div>
      </div>
    </>
  );
}

export default Navbar;
